import { render } from "./ResultDisplay.vue?vue&type=template&id=3dfb485f&scoped=true"
import script from "./ResultDisplay.vue?vue&type=script&lang=js"
export * from "./ResultDisplay.vue?vue&type=script&lang=js"

import "./ResultDisplay.vue?vue&type=style&index=0&id=3dfb485f&lang=scss&scoped=true"

import exportComponent from "/var/lib/buildkite-agent/builds/BKxAWS-i-01d4bca84f43bee68-1/assemble-sports/aucklandrugbyleague-livescores-production-vertical-traffic-light/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dfb485f"]])

export default __exports__